import { render, staticRenderFns } from "./zones.vue?vue&type=template&id=5ad58824"
import script from "./zones.js?vue&type=script&lang=js&external"
export * from "./zones.js?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports